import { useFilterMemberContext } from "./filter-member.context";

export function FilterMember() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterMemberContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}